import { Box } from '@chakra-ui/react';
import { Spinner } from '@chakra-ui/spinner';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import MapDirectionsRenderer from './DirectionsRenderer';
import { Route } from '../../../../../types/RoutePoint';

const googleMapsApiKey = 'AIzaSyCmpWpPIUgLejuVqKgXn-jub7gOQk-XBW8';
const midNorway = { lat: 60.843574, lng: 8.2469489 };
const zoom = 7;

interface MapProps {
  onRouteChange: (details: Route) => void;
  encodedPath?: any;
  displayOnly?: boolean;
}

export default function Map(props: MapProps) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleMapsApiKey,
  });
  const [waypoints, setWaypoints] = useState<google.maps.LatLng[]>([]);

  const existingPath = props.encodedPath;

  useEffect(() => {
    if (isLoaded && existingPath) {
      let lng = existingPath.map((node: any) => {
        return new google.maps.LatLng(node[0], node[1]);
      });
      setWaypoints(lng);
    }
  }, [existingPath, isLoaded]);

  function onClickMap(event: google.maps.MapMouseEvent) {
    if (props.displayOnly) return;
    if (waypoints.length >= 27) return; //cannot have more than 25 waypoints plus origin and destination
    if (event.latLng) setWaypoints(waypoints.concat(event.latLng));
    else console.log(event);
  }

  function onDirectionsError(error: string) {
    console.log(error);
    setWaypoints([]);
  }

  function getMapOptions() {
    if (props.displayOnly) {
      return { zoomControl: true, streetViewControl: false, fullscreenControl: false, mapTypeControl: false };
    }
    return {};
  }

  return (
    <>
      {isLoaded ? (
        <GoogleMap center={midNorway} zoom={zoom} onClick={onClickMap} options={getMapOptions()}>
          <MapDirectionsRenderer
            places={waypoints}
            travelMode={google.maps.TravelMode.DRIVING}
            onRouteChange={props.onRouteChange}
            onError={onDirectionsError}
            displayOnly={props.displayOnly}
          />
        </GoogleMap>
      ) : (
        <Box>
          <Spinner size='xl' />
        </Box>
      )}
    </>
  );
}
